export const prepareLanguageOptions = ({ languages }) =>
  languages.map(({ id, name }) => ({ value: id, label: name }));
